module.exports = __webpack_public_path__ + "static/media/banner.7e1af8d7.jpg";